export enum ReasonForNoShow {
  AllowedAbsence = 'Allowed absence',
  NotAllowedAbsence = 'Not allowed absence',
  Sickness = 'Sickness',
  Other = 'Other',
}
